export function convertPerformanceItems(receivedPerformanceItems, convertedMetricConfigs) {

    const metricMapping = {};

    const monthKeys = Object.keys(receivedPerformanceItems);
    for(const month of monthKeys) {
        const metricKeys = Object.keys(receivedPerformanceItems[month]);
        for(const metricName of metricKeys) {
            //Get metric config
            const metricConfig = convertedMetricConfigs[metricName];

            let metric = metricMapping[metricName];
            if(!metric) {
                metric = { 
                    name: metricName, 
                    ...metricConfig
                };
                metricMapping[metricName] = metric;
            }
            metric[month] = receivedPerformanceItems[month][metricName];
        }
    }

    const result = [];
    const keys = Object.keys(metricMapping);
    for(const key of keys) {
        result.push(metricMapping[key]);
    }

    return result;
}

export function convertMetricConfigs(receivedPerformanceMetricConfigs) {
    const result = {};

    receivedPerformanceMetricConfigs.forEach(item => {
        result[item.name.toLowerCase()] = {
            displayName: item.display_name,
            isFunnelMetric: item.is_funnel_metric,
            calculation: item.metric_calculation_id,
            format: item.format_id
        };
    });

    return result;
}

const monthFormatter = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    year: '2-digit'
});
  
export function formatMonth(originalString) { //string in the format YYYY-MM
    const [year, month] = originalString.split('-');
    let result = originalString;
    if(year && month) {
        //We set the day to 28 so that it also works with february.
        const date = new Date(parseInt(year), parseInt(month) - 1, 28);

        result = monthFormatter.format(date);
    }
    return result;
}